export const INDEX = "/";
export const HOME = "/home";
export const HOME_CAREERS = "/careers";
export const CAREERS_ROLE = "/careers/role/:roleId";
export const CAREERS_THANK_YOU = "/careers/submitted";
export const CAREERS_SUBMISSION_ERROR = "/careers/error";

export const HOME_TEST = "/home/test";
export const HOME_CONTACT = "/home/contact";
export const HOME_TOS = "/tos";
export const HOME_PRIVACY_POLICY = "/privacy";
export const HOME_COOKIES = "/cookies";
export const CCPA = "/ccpa";
export const SCAM_ALERTS = "/scam-alerts";
